import React from 'react';
import Countdown from 'react-countdown';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';

const CountdownTimer = () => {
  const { t } = useTranslation();
  const targetDate = new Date('2026-03-01T00:00:00');

  const renderer = ({ days, hours, minutes, seconds, completed }) => {
    if (completed) {
      return (
        <div className="text-center" data-testid="countdown-completed">
          <p className="text-2xl font-bold text-accent">{t('campaign.started')}</p>
        </div>
      );
    }

    return (
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="grid grid-cols-4 gap-4 md:gap-8 max-w-4xl mx-auto"
        data-testid="countdown-timer"
      >
        <div className="bg-white/90 backdrop-blur-md rounded-2xl p-6 shadow-xl text-center">
          <div className="text-5xl font-bold text-primary" style={{ fontFamily: 'Playfair Display, serif' }}>
            {days}
          </div>
          <div className="text-sm text-gray-600 mt-2 uppercase tracking-wide">
            {t('countdown.days')}
          </div>
        </div>
        <div className="bg-white/90 backdrop-blur-md rounded-2xl p-6 shadow-xl text-center">
          <div className="text-5xl font-bold text-secondary" style={{ fontFamily: 'Playfair Display, serif' }}>
            {hours}
          </div>
          <div className="text-sm text-gray-600 mt-2 uppercase tracking-wide">
            {t('countdown.hours')}
          </div>
        </div>
        <div className="bg-white/90 backdrop-blur-md rounded-2xl p-6 shadow-xl text-center">
          <div className="text-5xl font-bold text-accent" style={{ fontFamily: 'Playfair Display, serif' }}>
            {minutes}
          </div>
          <div className="text-sm text-gray-600 mt-2 uppercase tracking-wide">
            {t('countdown.minutes')}
          </div>
        </div>
        <div className="bg-white/90 backdrop-blur-md rounded-2xl p-6 shadow-xl text-center">
          <div className="text-5xl font-bold text-primary" style={{ fontFamily: 'Playfair Display, serif' }}>
            {seconds}
          </div>
          <div className="text-sm text-gray-600 mt-2 uppercase tracking-wide">
            {t('countdown.seconds')}
          </div>
        </div>
      </motion.div>
    );
  };

  return (
    <div className="my-16">
      <motion.h3
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        className="text-3xl font-bold text-center text-primary mb-8"
        style={{ fontFamily: 'Playfair Display, serif' }}
      >
        {t('campaign.timeRemaining')}
      </motion.h3>
      <Countdown date={targetDate} renderer={renderer} />
    </div>
  );
};

export default CountdownTimer;